import { useEffect, useState } from 'react';

const RESET_COPIED_STATE_TIMEOUT_MS = 2000;

export const useCopyToClipboard = () => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = (text: string) => {
    if (!text || !navigator?.clipboard?.writeText) return;
    // CI Chrome denies clipboard write permission. An uncaught rejection fails the spec.
    void navigator.clipboard
      .writeText(text)
      .then(() => setIsCopied(true))
      .catch(() => undefined);
  };

  useEffect(() => {
    if (!isCopied) return;

    const timeoutId = window.setTimeout(() => {
      setIsCopied(false);
    }, RESET_COPIED_STATE_TIMEOUT_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isCopied]);

  return { isCopied, copyToClipboard };
};
